export { default } from "./UsersQuery";



// WEBPACK FOOTER //
// ./src/queries/UsersQuery/index.ts